import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class TabularReportFilterModel extends BaseModel {
  static urlPath = "tabular_reports";

  @attr("string") type;
  @attr("string") label;
  @attr("json") options;
  @attr("string") api_url;
  @attr("json") query_params;
  @attr("json") min;
  @attr("json") max;
}
